import { PrimaryButton, Title, useThemeContext } from '@huggg/react-components';
import footerIllustration from 'assets/img/huggg-life/illustration_footer.svg';
import headerIllustration from 'assets/img/huggg-life/illustration_header.svg';
import config from 'config';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './huggg-life.module.scss';

const { hugggLifeBanner: text } = dictionary;

export const HugggLife = ({ url = config.hugggLifeUrl }) => {
  const { operator } = useThemeContext();
  if (!operator.showHugggPromotions) return null;
  return (
    <div className={styles.container}>
      <img className={styles.headerImage} src={headerIllustration} alt="" />
      <div />
      <div className={styles.copy}>
        <Title className={styles.title}>
          {text.action}&nbsp;<strong>{text.item}</strong>
        </Title>
        {text.body.map((line) => (
          <p key={line} className={styles.body}>
            {line}
          </p>
        ))}
      </div>
      <PrimaryButton
        className={styles.button}
        label={text.button}
        onClick={() => {
          window.location.assign(url);
        }}
      />
      <img className={styles.footerImage} src={footerIllustration} alt="" />
    </div>
  );
};

HugggLife.propTypes = {
  url: PropTypes.string,
};
